import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useFamilyAndFriends } from '../../hooks/useFamilyAndFriends';
import {
  IAddEmployeeInfo,
  newEmployeeInfo,
} from '../../types/employeeInfo';
import SelectTable from '../selectTable/selectTable';

type EmployeeSelectProps = {
  id: string;
  employee?: IAddEmployeeInfo;
  setEmployee: (val: IAddEmployeeInfo | undefined) => void;
  required?: boolean;
};

export default function EmployeeSelect(props: EmployeeSelectProps): React.ReactElement {
  const { id, employee, setEmployee, required } = props;
  const { data: employeeData, refetch } = useFamilyAndFriends();
  const location = useLocation();

  useEffect(() => {
    refetch();
  }, [location, refetch]);

  return (
    <SelectTable<IAddEmployeeInfo>
      id={id}
      required={required}
      displayVal={e => `${e?.firstName} ${e?.lastName}`}
      value={employee}
      validityTest={obj => !!(obj.firstName || obj.lastName || obj.driversLicenseNum)}
      noHeader
      preventClear
      setValue={setEmployee}
      data={
        employeeData?.getFamilyMembers.data?.map((e: any) => newEmployeeInfo(e)) || []
      }
      headers={[
        {
          label: 'Name',
          field: e => `${e.firstName} ${e.lastName}`,
        },
      ]}
      topHead={
        <div>
          <Link to="/resident/edit-profile/add-friends-and-family">
            Add Family and Friends
          </Link>
        </div>
      }
    />
  );
}

EmployeeSelect.defaultProps = {
  employee: undefined,
  required: undefined,
};
